import { useSortable } from "@dnd-kit/sortable";
import { SearchContext } from "context/providers";
import { useContext } from "react";
import ChipContent from "./ChipContent";
import { motion } from "framer-motion";

export default function Chip({ skill, skillType, isInteractable = true }) {
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: skill.name,
  });
  const { setSkillSearchState, searchState } = useContext(SearchContext);

  const { name, active, ai } = skill;

  const updateSkillList = (updater) => {
    setSkillSearchState({
      ...searchState.skills,
      [skillType]: updater(searchState.skills[skillType]),
    });
  };

  const handleRemoveSkill = () => {
    if (!isInteractable) return;
    updateSkillList((list) => list.filter((s) => s.name !== name));
  };

  const handleToggleDisableSkill = () => {
    if (!isInteractable) return;
    updateSkillList((list) =>
      list.map((s) => (s.name === name ? { ...s, active: !s.active } : s))
    );
  };

  const isAiGeneratedForSkillType =
    ai.isGenerated && ai.skillType === skillType;

  const passedProps = isInteractable ? { ...attributes, ...listeners } : {};

  return (
    <motion.div
      className="chip"
      id={`chip-${skill.name}`}
      layout
      layoutId={isDragging ? undefined : `chip-${skill.name}`}
    >
      <ChipContent
        ref={isInteractable ? setNodeRef : undefined}
        skill={skill}
        active={active}
        isAiGenerated={isAiGeneratedForSkillType}
        onClick={handleToggleDisableSkill}
        onRemove={handleRemoveSkill}
        isDragging={isDragging}
        {...passedProps}
      />
    </motion.div>
  );
}
